<template>
    <div class="upsert-contact-property-config">
        <div class="config-field">
            <label>{{ $t("contactModuleRules.upsertContactPropertyConfig.propertySelect") }}</label>
            <a-select
                v-model="localConfig.propertyId"
                :placeholder="$t('contactModuleRules.upsertContactPropertyConfig.selectProperty')"
                style="width: 100%;"
                :filter-option="filterOption"
                @change="emitChange"
            >
                <a-select-option
                    v-for="property in contactProperties"
                    :key="property._id"
                    :value="property._id"
                >
                    {{ property.label }}
                </a-select-option>
            </a-select>
            <small>{{ $t("contactModuleRules.upsertContactPropertyConfig.propertyHint") }}</small>
        </div>

        <div class="config-field">
            <label>{{ $t("contactModuleRules.upsertContactPropertyConfig.value") }}</label>
            <a-input
                v-model="localConfig.value"
                :placeholder="$t('contactModuleRules.upsertContactPropertyConfig.valuePlaceholder')"
                @change="emitChange"
            />
            <small>{{ $t("contactModuleRules.upsertContactPropertyConfig.valueHint") }}</small>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../../utils/log2";

const log = log2("UpsertContactPropertyConfig");

export default {
    name: "UpsertContactPropertyConfig",
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                propertyId: null,
                value: ""
            }
        };
    },
    computed: {
        ...mapState({
            contactProperties: state => state.contactProperty.data
        })
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && JSON.stringify(newVal) !== JSON.stringify(this.localConfig)) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }
    }
};
</script>

<style lang="scss" scoped>
.upsert-contact-property-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }
    }
}
</style>

